import React from "react";
import {Link} from "react-admin";
import {getTagForAIProcessResponse} from "@src/components/Common/Tags";
import {formatDateAndTime, formatDateAndTimeFromNowWithTooltip} from "@src/helpers/utils";
import {Button, Space, Tag, Tooltip, Typography} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRocket} from "@fortawesome/free-solid-svg-icons";
import {CustomPriceTag} from "@src/components/Common/utils";

const {Title, Text} = Typography;


export const getPipelineColumns = (retriggerPipeline: Function|null=null) => {

    return [
        {
            title: '',
            dataIndex: 'id',
            key: 'id',
            render: (text: any, record: any) => {
                const scope_name = record.scope_name
                const scope_id = record.scope_id

                return (
                    <Space orientation={"vertical"} size={1} wrap={true}>
                        <Space orientation={"horizontal"}>
                            <Title level={5}>#{record.id}</Title>
                            <FontAwesomeIcon icon={faRocket} style={{fontSize: '1em'}}/>
                            <div title={scope_name} style={{display: 'grid', placeItems: 'stretch'}}>
                                <Link style={{whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}
                                      to={`/owner_service_items/${scope_id}`}>{scope_name}</Link>
                            </div>
                            <span style={{
                                fontSize: '12px',
                                color: '#666',
                                backgroundColor: '#f5f5f5',
                                padding: '2px 6px',
                                borderRadius: '3px'
                            }}>
                                    v{record.version}
                                </span>
                            {record.applied && <Tag color="#87d068" style={{borderRadius: '12px'}}>Applied</Tag>}
                            <Text type="secondary">
                                <Tooltip title={formatDateAndTime(record.created)}>
                                    <Text className='text-sm'>
                                        Created {formatDateAndTimeFromNowWithTooltip(record.created)}
                                    </Text>
                                </Tooltip>
                            </Text>
                        </Space>

                    </Space>
                )
            }
        },
        {
            title: "State",
            dataIndex: "state",
            key: "state",
            render: (state: string) => (getTagForAIProcessResponse(state))
        },
        {
            title: "Current Stage",
            dataIndex: "current_stage",
            key: "current_stage",
        },
        {
            title: 'Cost',
            dataIndex: 'cost',
            key: 'cost',
            render: (cost: number) => CustomPriceTag(cost)
        },
        {
            title: '',
            key: 'actions',
            render: (text: any, record: any) => {
                const scope_id = record.scope_id
                return <Space orientation={"horizontal"}>
                    {retriggerPipeline && <Button type="primary" size="small" onClick={()=>{retriggerPipeline(scope_id)}}>Retrigger</Button>}
                    <Link to={`/owner_service_items/${scope_id}?tab=netorca_pack&pipeline_version=${record.version}`}>
                        <Button size="small">Details</Button>
                    </Link>
                </Space>
            }
        },
    ];
}
